export default {
  data() {
    return {

    };
  },
  methods: {
    visibilitychange() {
      console.log(document.visibilityState); // hidden visible
      if (document.hidden || document.visibilityState === 'hidden') {
        this.musicIndex = [];
        this.$el.querySelectorAll('.player').forEach((item, index) => {
          if (!item.paused) { // 如果没暂停
            item.pause();
            this.musicIndex.push(index);
          }
        });
      } else {
        console.log(this.musicIndex, 'this.musicIndexthis.musicIndex');
        this.musicIndex && this.musicIndex.forEach((i) => {
          this.$el.querySelectorAll('.player')[i].play();
        });
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.visibilitychange);
  },
  mounted() {
    document.addEventListener('visibilitychange', this.visibilitychange);
  },
};
